var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"project-by"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('landing.by')))]),_c('a',{staticClass:"company",attrs:{"href":"https://www.yara.com","target":"_blank","rel":"noopener"}},[_c('logo-yara')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }